<template>
    <div>
        <v-container>
            <v-row no-gutters>
                <v-col :cols="6">
                    <h1 class="headline font-weight-light mb-3">
                        <router-link
                            class="link-a"
                            :to="{
                                path: '/Inventory/Stock/' + pages,
                                query: { q: form_query },
                            }"
                            >STOCK</router-link
                        >
                        / STOCK IN
                    </h1>
                </v-col>
                <v-col :cols="6" class="text-right"> </v-col>
            </v-row>
            <v-form method="post" id="nativeForm" v-model="valid">
                <v-card outlined>
                    <v-row>
                        <v-col cols="6">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <div class="overline mb-4">
                                        {{ form.category_name }}
                                    </div>
                                    <v-list-item-title class="headline mb-1">{{
                                        form.part_name
                                    }}</v-list-item-title>
                                    <v-list-item-subtitle>{{
                                        form.part_description
                                    }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                        <v-col cols="6">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <div class="overline mb-4">
                                        SUPPLIER : {{ form.supplier_name }}
                                    </div>
                                    <v-list-item-title class="headline mb-1">{{
                                        form.project_name
                                    }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                    </v-row>
                </v-card>

                <v-card class="mt-5">
                    <v-card-title>
                        <span class="headline headline-2">Stock In Detail</span>
                    </v-card-title>
                    <v-row>
                        <v-col cols="12" sm="6" md="4" class="pa-7 mar-1">
                            <v-text-field
                                v-model="form.shipment"
                                label="Shipment"
                                :rules="ShipmentR"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" class="pa-7 mar-1">
                            <v-text-field
                                v-model="form.location"
                                label="Location"
                                :rules="LocationR"
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card class="mt-5">
                    <v-card-title>
                        <span class="headline headline-2"
                            >Serial Part / Qty</span
                        >
                    </v-card-title>

                    <v-row class="">
                        <v-col col="12" sm="6">
                            <v-switch
                                v-model="form.is_na"
                                class="ma-1 pa-3"
                                label="NA"
                            ></v-switch>
                        </v-col>
                    </v-row>
                    <v-row class="mar-2">
                        <v-col col="12" sm="6">
                            <v-text-field
                                v-if="form.is_na === true"
                                label="QTY"
                                ref="na"
                                class="ma-1 pa-3"
                                v-model="form.qty"
                                :rules="QtyR"
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mar-2">
                        <v-col col="12" sm="6">
                            <v-textarea
                                v-if="
                                    form.is_na === false ||
                                        form.is_na == '' ||
                                        form.is_na == undefined
                                "
                                outlined
                                class="ma-1 pa-3"
                                ref="serial_part"
                                name="serial_part"
                                label="Serial Part"
                                v-model="form.serial"
                                :rules="serial_partR"
                                required
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row class="mar-2">
                        <v-col cols="12" class="text-right">
                            <v-progress-linear
                                v-if="chk_save == true"
                                indeterminate
                                color="cyan"
                            ></v-progress-linear>
                            <v-btn
                                v-if="chk_save == false"
                                color="success"
                                class="mr-5"
                                @click="save()"
                                :disabled="!valid"
                                rounded
                            >
                                <v-icon small class="mr-1"
                                    >mdi-content-save</v-icon
                                >
                                Save</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-card>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import axios from "axios"
import VueRouter from "vue-router"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/stockin`
const url_2 = `${process.env.VUE_APP_ROOT_API}/api/stock/`

export default {
    computed: {
        ...mapState(["snackbar"]),
    },
    mounted() {
        this.get_data()
        this.pages = this.$route.params.pages
        this.form.is_na = false
        this.form_query = this.$route.query.q
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            let { data } = await axios.get(url)
            this.dataGet = data
            let data_2 = await axios.get(url_2 + this.$route.params.id)
            this.form = { ...data_2.data[0] }
            this.part_id = this.$route.params.id

            if (this.team_name === "ODM") {
                this.form.is_na = true
            }
        },
        async save() {
            this.chk_save = true
            await axios
                .post(url, this.form, {
                    headers: { Authorization: "Bearer " + localStorage.token },
                })
                .then((response) => {
                    this.chk_save = false
                    this.mutatesnackbar()
                    // this.$root.$router.push({
                    //     path: "/Inventory/Stock/" + this.pages,
                    // })
                    let urlx =
                        "/Inventory/Stock-In/Barcode/" +
                        1 +
                        "/" +
                        response.data.part_id
                    this.$router.push({
                        path: urlx,
                    })
                })
                .catch((error) => {
                    console.log(error)
                })
        },
    },
    data() {
        return {
            chk_save: false,
            dataGet: [],
            form: {
                part_id: null,
                is_na: false,
            },
            valid: false,
            pages: 0,
            ProjectR: [(v) => !!v || "Project Name is required"],
            CategoriesR: [(v) => !!v || "Categories is required"],
            SupplierR: [(v) => !!v || "Supplier is required"],
            ShipmentR: [(v) => !!v || "Shipment is required"],
            LocationR: [(v) => !!v || "Location is required"],
            part_noR: [(v) => !!v || "Part No is required"],
            QtyR: [
                (v) => !!v || "QTY is required",
                (v) => /^\d+$/.test(v) || "Must be a number",
            ],
            serial_partR: [(v) => !!v || "Serial Part is required"],
            team_name: localStorage.team_name,
            form_query: null,
        }
    },
}
</script>

<style scoped>
.mar-1 {
    margin-top: -30px;
    margin-left: 0px !important;
}
.mar-2 {
    margin-top: -30px;
}
@media screen and (max-width: 960px) and (min-width: 600px) {
    .mar-1 {
        margin-top: 0px !important;
        margin-left: 0px !important;
    }
}
</style>
